<footer class="footer">
  <div class="footer-lane" aria-hidden="true"><span class="footer-lane__strip"></span></div>
  <div class="footer-copyright">
    <div class="footer-container">
      <div class="footer-row">
        <img
          class="footer-logo"
          src="assets/images/brand/logo-white.svg"
          alt="DrivOn"
          width="199"
          height="64"
          loading="lazy"
        />
        <div class="copy-right text-left">
          © 2026 DrivOn Autoschool. All rights reserved
        </div>
        <a class="footer-phone" href="tel:+37441885885"
          ><i class="fas fa-phone-alt dv-ring" aria-hidden="true"></i
          ><span>+374 41885885</span></a
        >
        <ul class="social-media">
          <li
            *ngFor="let social of socialMedia; trackBy: trackByIndex"
            appReveal="rise"
            revealBatch
            [revealDistance]="12"
            revealStart="top bottom+=100"
          >
            <a
              [href]="social.link"
              [attr.aria-label]="social.label"
              appMagnetic
              target="_blank"
              rel="noopener noreferrer"
              ><i [ngClass]="social.icon" aria-hidden="true"></i
            ></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>
